/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * Side Bar Styled
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const SideBarNavContainerStyled = styled.div.attrs({
    'className': 'side-bar',
    'data-component': 'sideBarNav',
})<{ width: number; marginBottom: number }>`
    position: sticky;
    top: 0;
    z-index: 4;
    height: 100%;
    width: ${props => props.width}px;
    max-height: calc(100vh - ${props => props.marginBottom}px);
    overflow-y: auto;
    background: ${colors.backgroundColorModal};
    border-right: 1px solid ${colors.borderColorLight};
`;

export const SideBarContentContainerStyled = styled.div<{ navWidth: number; minHeight: number }>`
    width: calc(100% - ${props => props.navWidth}px);
    min-height: ${(props) => props.minHeight}px;
`;
